import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

import { propTypesDataInteractiveHorizontal } from './InteractiveHorizontal.proptypes';

import { TabContent } from './TabContent';
import { Tabs } from './Tabs';

import * as S from './InteractiveHorizontal.styles';

export const InteractiveHorizontalSlice = ({ slice }) => {
  const [currentTab, setCurrentTab] = useState(0);

  const { ref } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const data = slice.primary || {};
  const {
    interactive_horizontal_title: title,
    interactive_horizontal_id: sliceId,
  } = data || '';

  const items = slice.items;
  const defaultTabIndex = items.findIndex(
    tab => tab.interactive_horizontal_isvisible === true
  );

  useEffect(() => {
    setCurrentTab(defaultTabIndex);
  }, [defaultTabIndex]);

  return (
    <S.Wrapper id={sliceId} isVisible={true} ref={ref}>
      {title && <S.Title>{title}</S.Title>}
      <Tabs
        tabs={items}
        setCurrentTab={setCurrentTab}
        currentTab={currentTab}
      />
      <TabContent tabs={items} currentTab={currentTab} />
    </S.Wrapper>
  );
};

InteractiveHorizontalSlice.propTypes = {
  /**
   * Content of the HeaderBasic slice.
   */
  slice: PropTypes.shape(propTypesDataInteractiveHorizontal),
};
